<template>
  <Icon
    class="app-icon"
    :class="{ 'app-icon--spin': spin }"
    :icon="iconName"
    :width="size"
    :height="size"
    :color="color"
    :aria-hidden="title ? undefined : true"
    :aria-label="title"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Icon } from '@iconify/vue';
import { resolveRiIcon, type RiIconName } from '@/icons/ri';

const props = withDefaults(defineProps<{
  name: RiIconName | string;
  size?: number | string;
  color?: string;
  spin?: boolean;
  title?: string;
}>(), {
  size: '1em',
  color: 'currentColor',
  spin: false,
  title: undefined,
});

const iconName = computed(() => resolveRiIcon(props.name));
</script>

<style scoped>
.app-icon {
  display: inline-block;
  flex-shrink: 0;
  line-height: 1;
  vertical-align: -0.125em;
}

.app-icon--spin {
  animation: app-icon-spin 1s linear infinite;
}

@keyframes app-icon-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
